import { render, staticRenderFns } from "./ChangeTipDocument.vue?vue&type=template&id=d6137e78&scoped=true&"
import script from "./ChangeTipDocument.ts?vue&type=script&lang=ts&"
export * from "./ChangeTipDocument.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6137e78",
  null
  
)

export default component.exports
import {QSelect,QBtn} from 'quasar'
component.options.components = Object.assign({QSelect,QBtn}, component.options.components || {})
